import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { auth } from '../../firebase-functions/config';
import { onAuthStateChanged } from 'firebase/auth';
import { logInWithEmailAndPassword } from '../../firebase-functions/auth';
import { Link } from 'react-router-dom';
import { FaRegEyeSlash, FaEye } from 'react-icons/fa';
import { FaKeyboard } from 'react-icons/fa';
import { FaBookSkull } from 'react-icons/fa6';
import { Password } from './Password';
import { UserBox } from './UserBox';
import { RiRestartLine } from 'react-icons/ri';
import { AvatarView } from './StudentAccount/AvatarView';

const Login = () => {
  const [email, setEmail] = useState('');
  const [user, setUser] = useState(null);
  const [password, setPassword] = useState('');
  const [pet, setPet] = useState(1);
  const [seePasswrod, setSeePassword] = useState(false);
  const [iconPassword, setIconPassword] = useState(true);
  const [iconEmail, setIconEmail] = useState(true);
  const [step, setStep] = useState(2);

  useEffect(() => {
    onAuthStateChanged(auth, (u) => {
      if (u) {
        const toastId = 'AlreadyLoggedIn';

        setTimeout(() => {
          window.location.replace('/');
        }, 5000);
      }
    });
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      logInWithEmailAndPassword(email, password).then((res) => {
        if (res.success) {
          setTimeout(() => {
            window.location.replace('/');
          }, 3000);
        } else {
          toast.error('Email or password is wrong!');
        }
      });
    } catch (error) {
      toast.error('Error calling signUp function:', error.message);
      // Handle the error and show a message to the user
    }
  };

  return (
    <div className='container'>
      <div
        className='signup-container'
        // style={
        //   step === 3
        //     ? {
        //         backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.3)), url(https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fdashboard%2Fpexels-george-dolgikh-551816-1303081.jpg?alt=media&token=be47fb32-5fbc-4072-8ce4-1ace8b937e1b)`,

        //         backgroundRepeat: 'no-repeat, no-repeat',
        //         backgroundSize: 'cover, cover',
        //       }
        //     : {}
        // }
      >
        <form onSubmit={handleSubmit} id='emailForm' className='signup-form'>
          {(step === 1 || step === 2) && (
            <div className='form-group'>
              {/* <div className="label">
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setIconEmail(false);
                      }}
                    >
                      {" "}
                      <FaKeyboard className="password-icon" />
                    </button>
                  </div> */}
              <UserBox
                setEmail={setEmail}
                email={email}
                setLoginStep={setStep}
                setUser={setUser}
                step={step}
                setStep={setStep}
                pet={pet}
                setPet={setPet}
              />
            </div>
          )}

          {step === 3 && (
            <div className='form-group '>
              <div className='username-password-box-container'>
                <AvatarView
                  avatarInfo={user.avatar}
                  isLogin={true}
                  isMobile={window.innerWidth < 600}
                />
                <h3>{user.name}</h3>
                <Password setPassword={setPassword} />
                <div className='btn-container-restart-login'>
                  <button
                    className='user-password-btn-restart'
                    onClick={(e) => {
                      e.preventDefault();

                      setUser(null);
                      setPassword('');
                      setStep(2);
                    }}>
                    Go back <RiRestartLine />
                  </button>
                  {password.length > 1 ? (
                    <button
                      type='submit'
                      className='button btn-password-login'
                      style={{
                        opacity: password.length > 1 ? 1 : 0,
                      }}>
                      Log in
                    </button>
                  ) : (
                    <button className='btn-password-login-holder'></button>
                  )}
                </div>
              </div>
            </div>
          )}

          <br />
        </form>
      </div>

      <ToastContainer
        style={{
          position: 'top-center',
        }}
      />
    </div>
  );
};

export default Login;
